module.exports = __webpack_public_path__ + "static/media/zh-CN.43a5c8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/zh-CN.png
// module id = 959
// module chunks = 0